import EventBase from './EventBase'
import EventID from './EventID'



export default class EventTextDifExBase extends EventBase {
  /** 多语言工具链兼容 */
  eventLang: string | undefined
  langConfig: unknown

  protected InitialParam: string[]
  /**
   * 构造函数
   */
  constructor() {
    super()
    this.InitialParam = ['1', '0', '0', '0', '0', '', '0', '0']
  }
  /**
   * 剧情分歧
   */
  Code = EventID.TextDifEx
  // #region 类的相关绑定参数都在这里
  /**
   * 分歧数量
   */
  get DifCount() {
    return parseInt(this.Parameter?.[0].split('|')[1] ?? '')
  }
  set DifCount(value) {
    //Parameter[0].Split('|')[0] = "ORGTEXT";
    this.Parameter![0] = `ORGTEXT|${value}`
    // SetProperty(ref Parameter[0].Split('|')[1], value.ToString(), "DifCount");
  }
  /**
   * 是否居中
   */
  get IsCenter() {
    return this.Parameter?.[1] === '1'
  }
  set IsCenter(value) {
    this.Parameter && (this.Parameter[1] = value ? '1' : '0')
  }

  /**
   * X
   */
  get X() {
    return parseInt(this.Parameter?.[2] ?? '')
  }
  set X(value) {
    this.Parameter && (this.Parameter[2] = value.toString())
  }

  get Y() {
    return parseInt(this.Parameter?.[3] ?? '')
  }
  set Y(value) {
    this.Parameter && (this.Parameter[3] = value.toString())
  }

  /**
   * 倒计时时间
   */
  get CountDownTime() {
    return parseInt(this.Parameter?.[4] ?? '')
  }
  set CountDownTime(value) {
    this.Parameter && (this.Parameter[4] = value.toString())
  }

  /**
   * 计时条底图
   */
  get BarMap() {
    return this.Parameter?.[5] ?? ''
  }
  set BarMap(value) {
    this.Parameter && (this.Parameter[5] = value.toString())
  }

  /**
   * 计时条滚动图
   */
  get BarScrollMap() {
    return this.Parameter?.[6] ?? ''
  }
  set BarScrollMap(value) {
    this.Parameter && (this.Parameter[6] = value.toString())
  }

  /**
   * 计时条X
   */
  get BarX() {
    return parseInt(this.Parameter?.[7] ?? '')
  }
  set BarX(value) {
    this.Parameter && (this.Parameter[7] = value.toString())
  }

  /**
   * 计时条Y
   */
  get BarY() {
    return parseInt(this.Parameter?.[8] ?? '')
  }
  set BarY(value) {
    this.Parameter && (this.Parameter[8] = value.toString())
  }

  //   // #endregion
  /**
   * 获取描述信息
   */
  /// <returns></returns>

  makeNewLocalesValue(): void {}
}
